import React from 'react';
import dayjs from 'dayjs';
import TerminalHeader from './terminalHeader';
import { loadInvoicePreview, loadGroupInvoiceDetails } from '../printView/controler';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { ReactComponent as Calendar } from '../../../assets/custom/icons/calendar.svg';
//@ts-ignore
import QRCode from 'qrcode.react';
import { InvoiceTypeEnum } from '../checkout/interfaces';
import {
    CompanyInfoModel,
    CustomerInfoModel,
    RoomInfoMap,
    InvoicePresenter,
    IssuerCompanyInfo,
    ReservationModelWithModelsIncluded,
    InvoiceModelWithInvoiceItems,
    InvoiceType,
    GroupInvoiceDetails,
} from '@common/modelDefinition';
import translate from '@data/translations';
import { setInvoiceProperties } from '../checkout/controler';
import { updateAdvanceTimestamp } from '../printView/controler';
import useStore from '@data/state/zustand';
import countryCodes from '@common/countryCodes.json';
import DateTimeSelector from '@pages/newReservations/reservations/DateTimeSelector';
import 'dayjs/locale/sr';
import 'dayjs/locale/bs';
import 'dayjs/locale/hr';
export enum MethodOfPaymentEnum {
    G = 'Cash',
    K = 'Card',
    C = 'Cheque',
    T = 'Virman',
    O = 'Other',
    V = 'Virman',
}



export enum InvoiceTypeLabel {
    'R',
    'A',
    'P',
}

export interface InvoiceHeaderViewProps extends InvoicePresenter {
    setHTMLTitle?: boolean;
    showGuestsNumber?: boolean;
    showRooms?: boolean;
    translate: any;
    roomInfoMap?: RoomInfoMap;
    invoicingSettings?: any;
    refInvoice?: InvoiceModelWithInvoiceItems | null;
    fiscalGeneralSettings?: any;
    locale: string;
    invoiceToOnLeft?: boolean;
}

const InvoiceHeaderView = (props: InvoiceHeaderViewProps) => {
    const { invoice, translate, setHTMLTitle = false } = props;

    const roomInfoMap: RoomInfoMap = useStore.getState().map.RoomInfo();
    const groupInvoiceDetails: GroupInvoiceDetails = useStore(
        (appState: any) => appState.state.invoicePresenter.groupInvoiceDetails
    );
    const invoicingSettings = useStore((appState: any) => appState.invoicingSettings);
    const refInvoice: InvoiceModelWithInvoiceItems | null = useStore(
        (appState: any) => appState.state.invoicePresenter.refInvoice
    );
    const fiscalGeneralSettings = useStore((appState: any) => appState.fiscal.fiscalGeneralSettings);

    const allOtherProps = {
        roomInfoMap,
        groupInvoiceDetails,
        invoicingSettings,
        refInvoice,
        fiscalGeneralSettings,
    };

    const { invoiceType, reservationId, groupUuid, reclamation, terminalType, invoiceNumberFull } = invoice;

    if (!invoice) {
        return null;
    }

    let invoiceHeader: string | null = null;
    if (reclamation !== 2) {
        // 0 - nije reklamiran, 1 - reklamirani račun, 2 - storno računa (kopija sa negativnim vrijednostima)
        if (invoiceType === InvoiceTypeEnum.geniue) {
            invoiceHeader = translate('INVOICE');
        } else if (invoiceType === InvoiceTypeEnum.advance) {
            invoiceHeader = translate('ADVANCE INVOICE');
        } else if (invoiceType === InvoiceTypeEnum.proforma) {
            invoiceHeader = translate('PROFORMA INVOICE');
        } else if (invoiceType === InvoiceTypeEnum.proformaDispatched) {
            invoiceHeader = translate('PROFORMA DISPATCHED INVOICE');
        }
    } else {
        if (invoiceType === InvoiceTypeEnum.geniue) {
            invoiceHeader = translate('STORNO INVOICE');
        } else if (invoiceType === InvoiceTypeEnum.advance) {
            invoiceHeader = translate('STORNO ADVANCE INVOICE');
        } else if (invoiceType === InvoiceTypeEnum.proforma) {
            invoiceHeader = translate('STORNO PROFORMA INVOICE');
        } else if (invoiceType === InvoiceTypeEnum.proformaDispatched) {
            invoiceHeader = translate('STORNO PROFORMA DISPATCHED INVOICE');
        }
    }

    return (
        <div className="">
            <div>
                <div className="d-flex mt-8p">
                    {invoicingSettings?.invoiceToOnLeft ? (
                        <>
                            <div className="col-md-4 text-center border">
                                <InvoiceTo {...props} {...allOtherProps} />
                            </div>
                            <div className="col-md-8 ">
                                <InvoiceInfo invoiceToOnLeft={invoicingSettings?.invoiceToOnLeft} {...props} {...allOtherProps} />
                            </div>
                        </>
                    ) : (
                        <>
                            <div className="col-md-8 ">
                                <InvoiceInfo invoiceToOnLeft={invoicingSettings?.invoiceToOnLeft} {...props} {...allOtherProps} />
                            </div>
                            <div className="col-md-4 text-center border">
                                <InvoiceTo {...props} {...allOtherProps} />
                            </div>
                        </>
                    )}
                </div>
            </div>

            {terminalType === 'reservation' || terminalType === 'reservationConsumption' ? (
                groupUuid ? (
                    <GroupInfoHeader {...props} {...allOtherProps} />
                ) : reservationId ? (
                    <ReservationHeader {...props} {...allOtherProps} />
                ) : null
            ) : terminalType === 'posTerminal' || terminalType === 'minibar' ? (
                <TerminalHeader {...props} />
            ) : null}

            <div className=" text-center mt-4 mb-4">
                <h5>
                    {translate(invoiceHeader)} #{invoiceNumberFull}
                </h5>
            </div>
            {setHTMLTitle ? (
                <HelmetProvider>
                    <Helmet>
                        <title>{`${invoiceHeader}_${invoiceNumberFull}_res_${reservationId}`}</title>
                    </Helmet>
                </HelmetProvider>
            ) : null}
        </div>
    );
};

const InvoiceInfo = (props: InvoiceHeaderViewProps) => {
    const { invoice, translate, invoicingSettings, refInvoice, fiscalGeneralSettings, invoiceToOnLeft } = props;
    const {
        id,
        sfJIR,
        invoiceType,
        operatorName,
        timestamp,
        fiscalId,
        reclamationFiscalId,
        // reclamation,
        locale = 'eng',
        totalValue,
        invoiceNumber,
        businessSpaceLabel,
        tollDeviceLabel,
        typeOfPayment,
        fiscalSRCProxy,
        issuerSecurityCode,
        invoiceNumberFull,
        externalInvoiceNumber,
        advanceTimestamp,
    } = invoice;

    const [editAdvanceTimestamp, setEditAdvanceTimestamp] = React.useState(false as boolean);

    // const fiscalNumber = reclamation === 2 ? reclamationFiscalId : fiscalId;
    const issueDateTimestamp = timestamp ? timestamp : Date.now();
    const qrDate: string = timestamp ? dayjs(timestamp).format('YYYYMMDD') : '';
    const qrTime: string = timestamp ? dayjs(timestamp).format('HHMM') : '';
    const qrTotal: number = totalValue ? Number(totalValue.toFixed(2)) * 100 : 0;

    const { /*enableFiscalisation = false,*/ country = '' } = fiscalGeneralSettings
        ? fiscalGeneralSettings
        : { /*enableFiscalisation: false,*/ country: '' };

    const invoiceNumberFullPreview = invoiceNumberFull
        ? invoiceNumberFull
        : `${InvoiceTypeLabel[invoiceType]} - ${invoiceNumber ? invoiceNumber : ''} / ${dayjs(
              issueDateTimestamp
          ).format('YYYY')}`;

    const showInvoicingTime: boolean =
        invoicingSettings && invoicingSettings.showInvoicingTime !== undefined
            ? invoicingSettings.showInvoicingTime
            : true;
    const showInvoiceIssuedBy: boolean =
        invoicingSettings && invoicingSettings.showInvoiceIssuedBy !== undefined
            ? invoicingSettings.showInvoiceIssuedBy
            : true;

    return (
        <div>
            <div className="d-flex">
                <div className={"col-md-8  " + (invoiceToOnLeft ? "text-right" : "text-left")}>
                    <small>
                        <div>
                            <b>{translate('Invoice nr')}</b>: {invoiceNumberFullPreview}
                        </div>
                        {refInvoice ? (
                            <div>
                                <b>{translate('Ref. invoice')}</b>: {refInvoice.invoiceNumberFull}
                            </div>
                        ) : null}
                        <div>
                            <b>{translate('Date')}</b>: {dayjs(issueDateTimestamp).locale(locale).format('LL')}
                        </div>
                        {showInvoicingTime ? (
                            <div className="">
                                <b>{translate('Invoicing time')}</b>:{' '}
                                {dayjs(issueDateTimestamp).locale(locale).format('LLL')}
                            </div>
                        ) : null}
                        {invoiceType === InvoiceType.advance ? (
                            advanceTimestamp && !editAdvanceTimestamp ? (
                                <div className="flex-center ">
                                    <div>
                                        <b>{translate('Advance payment time')}</b>:{' '}
                                        {dayjs(advanceTimestamp ? advanceTimestamp : '')
                                            .locale(locale)
                                            .format('LLL')}
                                    </div>

                                    <div
                                        onClick={() => {
                                            setEditAdvanceTimestamp(!editAdvanceTimestamp);
                                        }}
                                        className="d-print-none pointer"
                                    >
                                        <Calendar />
                                    </div>
                                </div>
                            ) : (
                                <div className="flex-center">
                                    <b className='mr-4p'>{translate('Advance payment time')}:</b>{' '}
                                    <DateTimeSelector
                                        readOnly={false}
                                        dateTimePickHandler={async (timestamp: number) => {
                                            if (invoice.id) {
                                                const newInvoice = { ...invoice };
                                                newInvoice.advanceTimestamp = timestamp;
                                                if (invoice.pendingInvoice) {
                                                    setInvoiceProperties('advanceTimestamp', timestamp);
                                                    setEditAdvanceTimestamp(false);
                                                } else {
                                                    await updateAdvanceTimestamp(newInvoice);
                                                    setEditAdvanceTimestamp(false);
                                                }
                                            }
                                        }}
                                        value={
                                            invoice.advanceTimestamp ? invoice.advanceTimestamp : new Date().getTime()
                                        }
                                    />
                                    <div
                                        onClick={() => {
                                            setEditAdvanceTimestamp(!editAdvanceTimestamp);
                                        }}
                                        className="d-print-none pointer"
                                    >
                                        <Calendar width={24} height={24} />
                                    </div>
                                </div>
                            )
                        ) : null}

                        {businessSpaceLabel && tollDeviceLabel && externalInvoiceNumber ? (
                            <div>
                                <b>{translate('Invoice number')}</b>:{' '}
                                {`${externalInvoiceNumber}/${businessSpaceLabel}/${tollDeviceLabel}`}
                            </div>
                        ) : null}
                        {invoiceType === InvoiceTypeEnum.geniue && fiscalId && fiscalSRCProxy ? (
                            <div>
                                <b>F.BR</b>: {fiscalId}
                            </div>
                        ) : null}
                        {invoiceType === InvoiceTypeEnum.geniue && reclamationFiscalId && fiscalSRCProxy ? (
                            <div>
                                <b>R.F.BR</b>: {reclamationFiscalId}
                            </div>
                        ) : null}
                        {showInvoiceIssuedBy ? (
                            <div>
                                <b>{translate('Invoice issued by')} </b>: {operatorName}
                            </div>
                        ) : null}
                        <div>
                            <b>{translate('Method of payment')} </b>:{' '}
                            {translate(MethodOfPaymentEnum[typeOfPayment as keyof typeof MethodOfPaymentEnum])}
                        </div>
                        <div className="d-print-none">#{id}</div>
                    </small>
                </div>
                {sfJIR && country === 'CRO' ? ( //HR - ima sfJIR i fiscalNumber
                    <div className="col-md-4 text-center p-2">
                        <QRCode
                            value={`https://porezna.gov.hr/rn?jir=${sfJIR}&datv=${qrDate}_${qrTime}&izn=${qrTotal}`}
                            size={100}
                        />
                    </div>
                ) : invoiceToOnLeft ? null : (
                    //BiH - ima samo fiscalNumber
                    <div className="col-6 text-left"></div>
                )}
            </div>
            {invoiceType !== InvoiceTypeEnum.proforma &&
            invoiceType !== InvoiceTypeEnum.proformaDispatched &&
            sfJIR &&
            country === 'CRO' ? (
                <div className={"col-md-12 "  + (invoiceToOnLeft ? "text-right" : "text-left")}>
                    <b>JIR:</b> {sfJIR}
                </div>
            ) : invoice.id && !invoice.pendingInvoice && country === 'CRO' ? (
                <div className={"col-md-12 "  + (invoiceToOnLeft ? "text-right" : "text-left")}>OVO NIJE FISKALIZIRANI RAČUN</div>
            ) : null}
            {country === 'BIH-RS' && sfJIR ? (
                <div className={"col-md-12 "  + (invoiceToOnLeft ? "text-right" : "text-left")}>
                    <b>F.OZ:</b> {sfJIR}
                </div>
            ) : null}
            {issuerSecurityCode ? (
                <div className={"col-md-12 "  + (invoiceToOnLeft ? "text-right" : "text-left")}>
                    <b>ZKI:</b> {issuerSecurityCode}
                </div>
            ) : null}
            {(country === 'BIH' && !fiscalId) ||
            (country === 'BIH-RS' && !fiscalId && timestamp && timestamp < 1728640800000) ? (
                <div className={"col-md-12 "  + (invoiceToOnLeft ? "text-right" : "text-left")}>OVO NIJE FISKALNI RAČUN</div>
            ) : null}
            {country === 'BIH-RS' && !sfJIR && timestamp && timestamp > 1728640800000 ? (
                <div className={"col-md-12 "  + (invoiceToOnLeft ? "text-right" : "text-left")}>OVO NIJE FISKALNI RAČUN</div>
            ) : null}
            <div className="col-md-12 text-white">.</div>
            {/* <div className='col-md-12 text-white'>.</div>  */}
            {/* <div className='col-md-12 text-white'>.</div>  */}
        </div>
    );
};

interface groupReservationParams {
    reservationMadeBy: string | null;
    receptionistOIB: string | null;
    adultsNumberSum: number | null;
    roomInfo: any | null;
    adultsNumber: any | null;
}

const GroupInfoHeader = (props: InvoiceHeaderViewProps) => {
    const { invoice, translate, showGuestsNumber = true, showRooms = false, groupReservationsArray, invoicingSettings, roomInfoMap } = props;
    const { groupUuid, params, checkInTimestamp, checkOutTimestamp, locale } = invoice;

    const parsedParams: groupReservationParams = params ? JSON.parse(params) : {};
    const { reservationMadeBy = null, adultsNumberSum = null } = parsedParams;
    const showReservationMadeBy: boolean =
        invoicingSettings && invoicingSettings.showReservationMadeBy !== undefined
            ? invoicingSettings.showReservationMadeBy
            : true;
    return (
        <div className="col-md-12">
            <div>
                {/* <div className="col-6">
                <small>
                    <div>
                        <b>{translate('Group invoice')}</b>
                    </div>

                    {showReservationMadeBy ? (
                        <div>
                            <b>{translate('Group made by')}</b>: {reservationMadeBy}
                        </div>
                    ) : null}
                </small>
            </div> */}
                <div className="col-12">
                    <small>
                        {showReservationMadeBy ? (
                            <div>
                                <b>{translate('Group made by')}</b>: {reservationMadeBy}
                            </div>
                        ) : null}
                        {checkInTimestamp ? (
                            <div>
                                <b>{translate('Check in')}</b>: {dayjs(checkInTimestamp).locale(locale).format('LL')}
                            </div>
                        ) : null}
                        {checkOutTimestamp ? (
                            <div>
                                <b>{translate('Check Out')}</b>: {dayjs(checkOutTimestamp).locale(locale).format('LL')}
                            </div>
                        ) : null}

                        {showGuestsNumber && adultsNumberSum ? (
                            <div>
                                <b>{translate('Number of guests')}:</b>
                                {` ${adultsNumberSum}`}
                            </div>
                        ) : (
                            <div className="text-white">.</div>
                        )}
                        {groupReservationsArray && groupReservationsArray.length > 0 ? (
                            <div className={showRooms ? '' : 'd-none'}>
                                <b>{translate('Rooms')}:</b>{' '}
                                <span className="d-print-none">
                                    <RelatedReservationInvoicePreview groupUuid={groupUuid} {...props} />
                                </span>
                                <span className="d-none d-print-inline">
                                    {groupReservationsArray.map((r: ReservationModelWithModelsIncluded, i: number) => {
                                        const room = roomInfoMap ? roomInfoMap[r.roomInfoId] : null;
                                        const roomName = room ? room.name : String(r.roomInfoId);
                                        return i < groupReservationsArray.length - 1 ? `${roomName}, ` : roomName;
                                    })}
                                </span>
                            </div>
                        ) : null}
                    </small>
                </div>
                {/* <div className="col-6 ">
                <small>
                    {showGuestsNumber && adultsNumberSum ? (
                        <div>
                            <b>{translate('Number of guests')}:</b>
                            {` ${adultsNumberSum}`}
                        </div>
                    ) : null}
                    {groupReservationsArray && groupReservationsArray.length > 0 ? (
                        <div className="d-print-none">
                            <b>{translate('Rooms')}:</b>
                            <RelatedReservationInvoicePreview groupUuid={groupUuid} {...props} />
                        </div>
                    ) : null}
                </small>
            </div> */}
            </div>
            {/* <div className="text-white">.</div> */}
            {/* <hr/> */}
        </div>
    );
};

const ReservationHeader = (props: InvoiceHeaderViewProps) => {
    const { invoice, translate, showGuestsNumber, showRooms = false, invoicingSettings } = props;
    const {
        checkInTimestamp,
        checkOutTimestamp,
        //  timestamp,
        reservationId,
        params,
        // detailsLevel = 0,
        locale = 'eng',
    } = invoice;
    const showReservationMadeBy: boolean =
        invoicingSettings && invoicingSettings.showReservationMadeBy !== undefined
            ? invoicingSettings.showReservationMadeBy
            : true;
    const parsedParams = params ? JSON.parse(params) : {};
    //  const issueDateTimestamp = timestamp ? timestamp : Date.now();
    const {
        reservationMadeBy: reservationMakerName = null,
        roomName = null,
        adultsNumber = null,
        childrenNumber = null,
    } = parsedParams;

    return (
        <div className="d-flex justify-content-between mt-3 p-2">
            <div className="p-2">
                <small>
                    <div>
                        <b>{translate('Reservation id')}</b>: {reservationId}
                    </div>

                    {showReservationMadeBy ? (
                        <div>
                            <b>{translate('Reservation made by')}</b>: {reservationMakerName}
                        </div>
                    ) : null}
                </small>
            </div>
            <div className="p-2">
                <small>
                    <div>
                        <b>{translate('Check in')}</b>: {dayjs(checkInTimestamp).locale(locale).format('LL')}
                    </div>
                    <div>
                        <b>{translate('Check Out')}</b>: {dayjs(checkOutTimestamp).locale(locale).format('LL')}
                    </div>
                </small>
            </div>
            <div className="p-2 ">
                <small>
                    {roomName && showRooms && (
                        <div>
                            <b>{translate('ROOM NUMBER')}</b>: {roomName}{' '}
                        </div>
                    )}
                    {adultsNumber && showGuestsNumber && (
                        <div>
                            <b>{translate('Adults')}</b>: {adultsNumber}{' '}
                        </div>
                    )}
                    {childrenNumber && showGuestsNumber ? (
                        <div>
                            <b>{translate('Children')}</b>: {childrenNumber}{' '}
                        </div>
                    ) : (
                        ''
                    )}
                </small>
            </div>
        </div>
    );
};

const InvoiceIssuer = (props: InvoiceHeaderViewProps) => {
    const invoicingSettings = useStore((appState: any) => appState.invoicingSettings);

    const { invoice, translate } = props;
    const { issuerCompanyInfo } = invoice;
    if (!issuerCompanyInfo) {
        return translate('Add your company info');
    }
    const p: IssuerCompanyInfo = JSON.parse(issuerCompanyInfo);
    const showIssuerName: boolean =
        invoicingSettings && invoicingSettings.showIssuerName !== undefined ? invoicingSettings.showIssuerName : true;

    return (
        <div className="border-bottom mb-1 p-2 d-print-none">
            <h5>{p.hotelName}</h5>
            {showIssuerName ? <b>{p.name}</b> : null}
            <div>{p.idNumber}</div>
            <div>{p.address}</div>
            <div>
                {p.postOfficeNumber} {p.town}
            </div>
        </div>
    );
};

export interface InvoiceToOverrideCompany {
    name: string;
    vatNumber: string;
    idNumber: string;
    address: string;
}

export interface InvoiceToOverride {
    company: InvoiceToOverrideCompany | null;
    guestNames: string[];
}

const InvoiceTo = (props: InvoiceHeaderViewProps) => {
    const { invoice, translate } = props;
    const { customerInfo, companyInfo } = invoice;
    const invoiceToOverride: InvoiceToOverride | null = useStore(
        (appState: any) => appState.state.invoicePresenter.invoiceToOverride
    );

    if (!customerInfo && !companyInfo && !invoiceToOverride) {
        return <div>{translate('')}</div>;
    }
    const customer: CustomerInfoModel = customerInfo ? JSON.parse(customerInfo) : null;
    const company: CompanyInfoModel = companyInfo ? JSON.parse(companyInfo) : null;
    const originalCustomerName: string =
        customer && customer.firstName ? `${customer.firstName} ${customer.lastName}` : ''; //treba viditi ima li ovo kada je kompanija u pitanju, ako nema, treba ubaciti na backend kontroleru
    const countryObj =
        company && company.country && countryCodes
            ? countryCodes.find((c) => c['country-code'] === company.country)
            : null;
    const country = countryObj ? `${countryObj['alpha-3']}` : '';

    const overrideCompany = invoiceToOverride?.company;
    const overrideHasCompanyData: boolean = Boolean(
        overrideCompany &&
            (overrideCompany.name || overrideCompany.vatNumber || overrideCompany.idNumber || overrideCompany.address)
    );
    const showCompany: boolean = Boolean(companyInfo) || overrideHasCompanyData;

    const guestNamesOverride: string =
        invoiceToOverride?.guestNames && invoiceToOverride.guestNames.length > 0
            ? invoiceToOverride.guestNames.join(', ')
            : '';
    const displayGuestNames: string = guestNamesOverride || originalCustomerName;

    const displayCompanyName: string = overrideCompany?.name || company?.name || '';
    const displayVatNumber: string | undefined = overrideCompany?.vatNumber || company?.vatNumber;
    const displayIdNumber: string | undefined = overrideCompany?.idNumber || company?.idNumber;
    const displayAddress: string | undefined = overrideCompany?.address || company?.address;

    if (showCompany) {
        return (
            <div>
                <h5>{displayCompanyName}</h5>
                {company?.oib ? <div>{company.oib}</div> : null}
                <div>
                    {company?.poNumber} {company?.town}
                </div>
                <div>{displayAddress}</div>
                {<div>{country}</div>}
                {displayIdNumber ? <div>{displayIdNumber}</div> : null}
                {displayVatNumber ? <div>{displayVatNumber}</div> : null}
                <div>{displayGuestNames}</div>
            </div>
        );
    } else {
        return (
            <div>
                <h5>{displayGuestNames}</h5>
                <div>{customer?.address}</div>
                <div>
                    {customer?.poNumber} {customer?.town}
                </div>
                {/* <div>{country}</div> */}
            </div>
        );
    }
};

interface RelatedReservationInvoicePreviewProps extends InvoiceHeaderViewProps {
    groupUuid: string | null;
}

const RelatedReservationInvoicePreview = (props: RelatedReservationInvoicePreviewProps) => {
    const { groupUuid, roomInfoMap, groupReservationsArray, groupInvoiceDetails, invoice, location } = props;
    // Sobe sa linkovima na pojedinačni invoice

    if (!groupReservationsArray) {
        return null;
    }

    const invoiceView = location && location.pathname.lastIndexOf('invoiceView') !== -1 ? true : false;

    return (
        <div className="btn-group mb-2 mb-md-0 flex-wrap" role="group" aria-label="Select reservation">
            {groupReservationsArray.map((r: ReservationModelWithModelsIncluded) => {
                const room = roomInfoMap ? roomInfoMap[r.roomInfoId] : null;
                const roomName = room ? room.name : '';
                return invoiceView ? (
                    <React.Fragment key={r.id}>
                        <button
                            key={r.id}
                            onClick={() => {
                                loadInvoicePreview(r.id);
                            }}
                            className={
                                invoice && Number(r.id) === invoice.reservationId
                                    ? 'btn btn-sm btn-secondary d-print-none'
                                    : 'btn btn-sm btn-outline-secondary d-print-none'
                            }
                        >
                            {roomName ? roomName : r.roomInfoId}
                        </button>
                        <span key={'non-print ' + r.id} className="d-none d-print-block">
                            {roomName ? roomName : r.roomInfoId}
                            {', '}
                        </span>
                    </React.Fragment>
                ) : (
                    <span key={'preview' + r.id} className="">
                        {roomName ? roomName : r.roomInfoId}
                        {', '}
                    </span>
                );
            })}
            {groupReservationsArray.length > 0 && invoiceView ? (
                <React.Fragment>
                    <button
                        onClick={() => {
                            loadGroupInvoiceDetails(groupUuid);
                        }}
                        className={
                            groupInvoiceDetails && // 👈 null and undefined check
                            Object.keys(groupInvoiceDetails).length > 0
                                ? 'btn btn-sm btn-secondary d-print-none'
                                : 'btn btn-sm btn-outline-secondary d-print-none'
                        }
                    >
                        {translate('All')}
                    </button>
                </React.Fragment>
            ) : null}
        </div>
    );
};

const SingleReservationInvoiceHeader = (props: InvoiceHeaderViewProps) => {
    const invoicingSettings = useStore((appState: any) => appState.invoicingSettings);

    return (
        <div className="">
            <div className="row text-center ">
                <div className="col-6">
                    <InvoiceIssuer {...props} />
                </div>
                <div className="col-6">
                    <div className="border">
                        <InvoiceTo {...props} />
                    </div>
                </div>
            </div>

            <ReservationHeader {...props} invoicingSettings={invoicingSettings} />
        </div>
    );
};

export default InvoiceHeaderView;

export { InvoiceIssuer, SingleReservationInvoiceHeader };
